module.exports = __webpack_public_path__ + "media/input6.ef14ad9b.wav";